{
  "_meta": {
    "_comment": "Phase 14.1 Wave 8 Task 40 — merchant orders namespace (embroidery 2-step accept dialog). vg-binding: P14.1.D-04 / P14.1.D-18 / INTERFACE-STANDARDS:error-shape",
    "locale": "vi"
  },
  "embAccept": {
    "title": "Phí thêu chờ duyệt",
    "titleWithOrder": "Phí thêu chờ duyệt — Đơn {{orderNumber}}",
    "subtitle": "Phí tính theo số mũi thực tế từ file digitize.",
    "deadlineBadge": "Còn {{remaining}}",
    "deadlineTooltip": "Quá hạn 72 giờ, đơn sẽ tự huỷ và hoàn đủ tiền.",
    "deadlineAt": "Hạn phản hồi: {{deadline}}",
    "colArtwork": "Artwork / mặt",
    "colPosition": "Vị trí",
    "colStitches": "Số mũi",
    "colFee": "Phí",
    "positionFirst": "Đầu tiên",
    "positionSubsequent": "Tiếp theo",
    "total": "Tổng phí thêu",
    "acceptButton": "Chấp nhận phí thêu {{amount}}",
    "accepting": "Đang xử lý…",
    "cancel": "Huỷ",
    "autoCancelNote": "Không phản hồi trong 72 giờ: đơn tự huỷ và hoàn đủ tiền vào ví. Thao tác chống trùng lặp (idempotency — chống xử lý lặp cùng một yêu cầu).",
    "success": "Đã chấp nhận phí thêu.",
    "networkFallback": "Lỗi mạng - kiểm tra kết nối",
    "remaining": {
      "expired": "Đã quá hạn",
      "hoursMinutes": "{{hours}} giờ {{minutes}} phút",
      "minutes": "{{minutes}} phút"
    },
    "errors": {
      "notPending": "Phí này không còn chờ duyệt — hộp thoại sẽ được làm mới.",
      "quoteMismatch": "Phí đã thay đổi kể từ khi tải — hãy xem lại bảng chi tiết.",
      "walletInsufficient": "Số dư ví không đủ — hãy nạp thêm để chấp nhận phí này."
    }
  },
  "payBulk": {
    "resultPaidList": "Đã thanh toán: {{list}}",
    "resultSkippedHeading": "Đã bỏ qua ({{n}}) — các đơn sau chưa bị trừ tiền:",
    "toast": {
      "payBulkSummary": "{{paidCount}} đơn đã thanh toán, {{skippedCount}} đơn bỏ qua — đã trừ {{totalDebited}}.",
      "payBulkInvalid": "Không gửi được lệnh thanh toán hàng loạt. Hãy kiểm tra lại danh sách đã chọn và thử lại."
    },
    "reason": {
      "PRICE_CHANGED": "Giá đã thay đổi — hãy lấy báo giá mới",
      "SHIPPING_CHANGED": "Phí vận chuyển đã thay đổi — hãy lấy báo giá mới",
      "TAX_CHANGED": "Thuế suất đã thay đổi — hãy lấy báo giá mới",
      "EXPIRED": "Báo giá đã hết hạn — hãy lấy báo giá mới",
      "CART_CHANGED": "Nội dung đơn đã thay đổi — kiểm tra lại đơn rồi lấy báo giá mới",
      "CONSUMED": "Đã thanh toán — đơn này được trừ tiền trước đó",
      "MISSING_SNAPSHOT": "Đơn chưa có báo giá hợp lệ — hãy lấy báo giá mới",
      "QUOTE_STALE": "Báo giá không còn hiệu lực — hãy lấy báo giá mới",
      "WALLET_INSUFFICIENT": "Số dư không đủ — hãy nạp thêm rồi thử lại",
      "SHIPPING_UNAVAILABLE": "Không có dịch vụ vận chuyển tới địa chỉ này — mở đơn để đổi địa chỉ",
      "PRICING_MISMATCH": "Lỗi tính giá — chưa trừ tiền, vui lòng thử lại",
      "IDEMPOTENCY_KEY_REUSE": "Đơn đã thay đổi sau khi bắt đầu thanh toán — tải lại rồi thử lại",
      "ORDER_FORBIDDEN": "Bạn không còn quyền truy cập đơn này",
      "ORDER_NOT_FOUND": "Đơn hàng không còn tồn tại"
    }
  }
}
